export default {
    finance: {
        loanPrograms: {
            title: "Leningprogramma's",
            create: "Leningprogramma maken",
            edit: "Leningprogramma bewerken",
            details: "Programmadetails",
            programTitle: "Programmatitel",
            programLogo: "Programmalogo",
            applicationForm: "Aanvraagformulier",
            viewApplications: "Aanvragen bekijken",
            cooperative: "Cooperatie",
            bank: "Bank",
            status: "Status",
            allStatuses: "Alle statussen",
            active: "Actief",
            inactive: "Inactief",
            approvalFlowSetting: "Instelling goedkeuringsstroom",
            concludeBeforeBank: "Rond een leningaanvraag af voordat deze naar de bank wordt gestuurd.",
            allowBankRequestInfo: "Sta de bank toe om meer informatie aan de aanvrager te vragen.",
            currency: "Valuta",
            loanAmountMin: "Leenbedrag - Minimum",
            loanAmountMax: "Leenbedrag - Maximum",
            term: "Looptijd",
            yield: "Rendement",
            typeOfFinancing: "Type financiering",
            gracePeriod: "Graceperiode",
            country: "Land",
            regions: "Regio's",
            crops: "Gewassen",
            dataFields: "Gegevensvelden",
            dataFieldsConfigured: "Gegevensvelden geconfigureerd voor dit leningprogramma",
            signature: "Handtekening",
            viewSignatureFile: "Handtekening / bestand bekijken",
            description: "Beschrijving",
            conditionsRequirements: "Voorwaarden en vereisten",
            digitalSignature: "Digitale handtekening",
            fileUpload: "Bestand uploaden",
            failedLoadLoanProgramDetails: "Kan details van leningprogramma niet laden",
            failedLoadLoanProgram: "Kan leningprogramma niet laden",
            failedLoadApplicationForm: "Kan aanvraagformulier niet laden",
            loanProgramUpdatedSuccess: "Leningprogramma succesvol bijgewerkt",
            loanProgramCreatedSuccess: "Leningprogramma succesvol aangemaakt",
            applicationFormUpdatedSuccess: "Aanvraagformulier succesvol bijgewerkt",
            failedUpdateLoanProgram: "Kan leningprogramma niet bijwerken",
            failedCreateLoanProgram: "Kan leningprogramma niet aanmaken",
            failedUpdateApplicationForm: "Kan aanvraagformulier niet bijwerken",
            fillRequiredFields: "Vul alle verplichte velden in",
            fileUploadRequiredFor: "Een bestandsupload is vereist voor",
            selectAtLeastOneOptionFor: "Selecteer minimaal een optie voor",
            fieldRequired: "Dit veld is verplicht",
            chooseValidOptionFor: "Kies een geldige optie voor",
            enterValidAmountFor: "Voer een geldig bedrag in voor",
            selectValidUnitFor: "Selecteer een geldige eenheid voor",
            step1ProgramDetails: "Stap 1: Programmadetails",
            step2ApplicationForm: "Stap 2: Aanvraagformulier",
            months: "maanden",
            years: "jaren",
            days: "dagen",
            weeks: "weken",
            previewForm: "VOORBEELD FORMULIER",
            backUpper: "TERUG",
            basicInformation: "Basisinformatie",
            basicInformationHint: "Voer de basisinformatie in voor het leningprogramma.",
            enterProgramTitle: "Voer programmanaam in",
            attachProgramLogo: "Programmalogo toevoegen",
            selectProgramLogoImage: "Selecteer programmalogo-afbeelding",
            selectFileUploadProgramLogo: "Selecteer bestand om programmalogo te uploaden",
            orDragDrop: "of sleep en zet hier neer",
            removeFile: "Bestand verwijderen",
            loanProgramSettings: "Instellingen leningprogramma",
            loanProgramSettingsHint: "Voer de instellingen voor het leningprogramma in.",
            selectBank: "Selecteer bank",
            applicationApproval: "Goedkeuring aanvraag",
            applicationProcess: "Aanvraagproces",
            loanDetails: "Leningdetails",
            loanDetailsHint: "Voer de leningdetails in voor het leningprogramma.",
            selectCurrency: "Selecteer valuta",
            enterMinLoanAmount: "Voer minimaal leenbedrag in",
            enterMaxLoanAmount: "Voer maximaal leenbedrag in",
            enterHere: "Voer hier in",
            interestRate: "Rentepercentage",
            yieldPerYear: "Rendement - per jaar",
            enterYieldPerYear: "Voer jaarlijks rendement in",
            selectTypeOfFinancing: "Selecteer type financiering",
            gracePeriodMax: "Graceperiode - Maximum",
            selectCrops: "Selecteer gewassen",
            selectCountry: "Selecteer land",
            selectRegions: "Selecteer regio's",
            addNewDataField: "NIEUW GEGEVENSVELD TOEVOEGEN",
            enterProgramDescription: "Voer programmabeschrijving in",
            programApplicationForm: "Programma-aanvraagformulier",
            defineAndManageCustomDataFields: "Definieer en beheer aangepaste gegevensvelden voor de leningaanvraag.",
            addDataField: "GEGEVENSVELD TOEVOEGEN",
            dataField: "Gegevensveld",
            type: "Type",
            subdata: "Subgegevens",
            mandatory: "Verplicht",
            group: "Groep",
            yes: "Ja",
            no: "Nee",
            noDataFieldsYet: "Nog geen gegevensvelden toegevoegd. Klik op GEGEVENSVELD TOEVOEGEN om er een te maken.",
            textField: "Tekstveld",
            textArea: "Tekstvak",
            textFieldNumeric: "Numeriek tekstveld",
            radioButton: "Keuzerondje",
            checkBoxes: "Selectievakjes",
            dropdown: "Dropdown",
            measurementUnit: "Maateenheid",
            attachFile: "Bestand toevoegen",
            digitalSignatureLabel: "Digitale handtekening",
            dataList: "Gegevenslijst",
            date: "Datum",
            selectDataType: "Selecteer gegevenstype",
            fieldTitle: "Veldtitel",
            groupTitle: "Groepstitel",
            enterGroupTitle: "Voer groepstitel in",
            allowMultipleInputs: "Meerdere invoeren toestaan",
            allowedFileTypes: "Toegestane bestandstypen",
            imageJpegGifPng: "Afbeelding (JPEG, GIF, PNG)",
            videoMp4: "Video (MP4)",
            docx: "DOCX",
            options: "Opties",
            typeHere: "Typ hier",
            unitType: "Eenheidstype",
            selectUnitType: "Selecteer eenheidstype",
            selectType: "Selecteer type",
            allowUserToChangeUnitType: "Gebruiker toestaan om eenheidstype te wijzigen",
            help: "Hulp",
            writeHelpTextUsers: "Schrijf een helptekst voor de gebruikers.",
            helpText: "Helptekst",
            addHelpTextForThisDataField: "Voeg helptekst toe voor dit gegevensveld",
            addFieldToGroup: "Veld toevoegen aan groep",
            cancelUpper: "ANNULEREN",
            submitUpper: "VERZENDEN",
            groupTitleRequired: "Groepstitel is verplicht",
            atLeastOneFieldRequiredInGroup: "Minstens een veld is verplicht in een groep",
            fieldTitleRequiredForAllGroupFields: "Veldtitel is verplicht voor alle groepsvelden",
            atLeastOneOptionRequiredFor: "Minstens een optie is verplicht voor",
            atLeastOneFileTypeMustBeSelected: "Minstens een bestandstype moet worden geselecteerd",
            fieldTitleRequired: "Veldtitel is verplicht",
            atLeastOneOptionRequired: "Minstens een optie is verplicht",
        },
        loanApplications: {
            activityDescription: "Activiteitsbeschrijving",
            activityLog: "Activiteitenlog",
            addAnyInternalNotesOrReviewCommentsAboutThisLoanApplication: "Voeg interne notities of reviewcommentaar toe over deze leningaanvraag.",
            additionalInformationRequested: "Extra informatie aangevraagd",
            additionalLoanRelatedQuestionsAndSupportingDocuments: "Extra leninggerelateerde vragen en ondersteunende documenten.",
            additionalQuestions: "Extra vragen",
            address: "Adres",
            amount: "Bedrag",
            applicantDetails: "Gegevens aanvrager",
            applicationHasBeenSentToTheBankForApproval: "De aanvraag is naar de bank gestuurd voor goedkeuring.",
            applicationId: "Aanvraag-ID",
            applicationIdAndSubmissionDate: "Aanvraag-ID en indieningsdatum",
            apply: "Toepassen",
            approvalProcess: "Goedkeuringsproces",
            approvalProcessHasBeenStartedYouCanNowFillFinalizeContractAndLoanDetails: "Het goedkeuringsproces is gestart. U kunt nu Contract afronden en Leningdetails invullen.",
            approve: "Goedkeuren",
            approved: "Goedgekeurd",
            areYouSureYouWantToApproveTheLoanApplication: "Weet u zeker dat u de leningaanvraag wilt goedkeuren?",
            areYouSureYouWantToRejectTheLoanApplication: "Weet u zeker dat u de leningaanvraag wilt afwijzen?",
            areYouSureYouWantToSendTheApplicationToTheBankForApprovalProcess: "Weet u zeker dat u de aanvraag naar de bank wilt sturen voor het goedkeuringsproces?",
            areYouSureYouWantToStartTheApprovalProcess: "Weet u zeker dat u het goedkeuringsproces wilt starten?",
            area: "Oppervlakte",
            areaHa: "Oppervlakte (ha)",
            attachContractOptional: "Contract bijvoegen (optioneel)",
            attachment: "Bijlage",
            back: "Terug",
            cancel: "Annuleren",
            circular: "Circulair",
            close: "Sluiten",
            closeUpper: "SLUITEN",
            confirm: "Bevestigen",
            confirmation: "Bevestiging",
            contract: "Contract",
            couldNotLoadLoanApplication: "Leningaanvraag kon niet worden geladen.",
            couldNotSendRequest: "Verzoek kon niet worden verzonden.",
            couldNotUpdateApplication: "Aanvraag kon niet worden bijgewerkt.",
            country: "Land",
            customization: "Aanpassing",
            date: "Datum",
            dateAndTime: "Datum en tijd",
            describeHere: "Beschrijf hier",
            description: "Beschrijving",
            digitallySigned: "Digitaal ondertekend",
            disclaimerTitle: "Disclaimer",
            disbursedAmount: "Uitbetaald bedrag",
            disbursementScheduleFromBankToFarmer: "Uitbetalingsschema van bank naar boer.",
            doYouWantUsToCollectTheContractSignature: "Wilt u dat wij de contractondertekening verzamelen?",
            doYouWantUsToCollectTheContractSignatureIfYesAttachTheContractOptionalAndWeWillSendItToTheFarmerToSignInTheAppIfNoTheContractIsAlreadySignedOrWillBeSignedOfflineAfterYouAttachAndSaveTheContractWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Wilt u dat wij de contractondertekening verzamelen? Zo ja, voeg het contract toe (optioneel) en wij sturen het naar de boer om in de app te tekenen. Zo nee, het contract is al ondertekend of wordt offline ondertekend. Na bijvoegen en opslaan wordt het contract naar de boer gestuurd; u ontvangt een melding zodra het is getekend.",
            download: "Downloaden",
            dueDate: "Vervaldatum",
            email: "E-mail",
            enterHere: "Voer hier in",
            error: "Fout",
            farm: "Bedrijf",
            farmDetails: "Bedrijfsgegevens",
            farmReports: "Bedrijfsrapporten",
            farmer: "Boer",
            farmerResponse: "Reactie boer",
            farmerUpdates: "Updates van de boer",
            farmReportsSoilDisclaimer: "De informatie in deze sectie is alleen voor algemene referentie. Het vervangt geen professionele bodemanalyse in het lab. Gebruik deze informatie alleen als andere opties ontbreken. Raadpleeg altijd landbouwexperts voordat u beslist.",
            farmReportsYieldBullet1: "Het is onmogelijk het weer voor een heel seizoen nauwkeurig te voorspellen; soms verliezen boeren de hele oogst door hagel of overstroming (zeker met klimaatverandering en onregelmatigheden).",
            farmReportsYieldBullet2: "Opbrengsten hangen sterk af van bedrijfsvoering. Bijvoorbeeld: te late bestrijding of onvoldoende irrigatie kan sterk afwijken van de voorspelling; dat ligt ook buiten onze controle.",
            farmReportsYieldBullet3: "Veel andere factoren kunnen grote fouten in AI-opbrengstvoorspellingen veroorzaken.",
            farmReportsYieldBullet4: "Als de boer historische opbrengsten levert (GEAVANCEERD), zijn voorspellingen meestal nauwkeuriger dan in de standaardmodus (niet-GEAVANCEERD).",
            farmReportsYieldUncertaintyIntro: "Bij onze opbrengstvoorspellingen kan de onzekerheid 100% zijn omdat veel factoren buiten onze controle vallen, waaronder:",
            forecastedYields: "Verwachte opbrengsten",
            graph: "Grafiek",
            yieldsKgAxis: "Opbrengsten (kg)",
            yieldForecasts: "Opbrengstvoorspellingen",
            farmerUploadedAttachmentS: "Boer heeft bijlage(n) geupload.",
            finalizeContract: "Contract afronden",
            financeManagement: "Financieel beheer",
            firstName: "Voornaam",
            generatePaymentSchedule: "BETALINGSSCHEMA GENEREREN",
            geolocation: "Geolocatie",
            gracePeriod: "Graceperiode",
            gracePeriodType: "Type graceperiode",
            historyOfActionsTakenOnThisLoanApplication: "Geschiedenis van acties op deze leningaanvraag.",
            ifYouWantUsToCollectTheApplicantSSignatureChooseYesAndAttachTheContractAfterYouSaveItWillBeSentToTheFarmerToSignInTheAppYouLlReceiveANotificationOnceSignedContractUploadIsOptionalEGIfTheContractIsAlreadySignedOrWillBeSignedOffline: "Als wij de handtekening van de aanvrager moeten verzamelen, kies Ja en voeg het contract toe. Na opslaan wordt het naar de boer gestuurd om in de app te tekenen; u krijgt een melding zodra het is getekend. Upload is optioneel (bijv. al ondertekend of offline).",
            information: "Informatie",
            informationRequestedFromBank: "Informatie aangevraagd bij de bank",
            installment: "Termijn",
            installmentDetails: "Termijndetails",
            interestRate: "Rentepercentage",
            ipAddress: "IP-adres",
            keySoilNutrientLevelsForTheFarm: "Belangrijkste bodemvoedingsstoffen voor het bedrijf.",
            landSuitabilityReport: "Rapport bodemgeschiktheid",
            lastName: "Achternaam",
            loadingData: "Gegevens laden...",
            loanAmount: "Leningbedrag",
            loanApplicationDetails: "Details leningaanvraag",
            loanApplicationHasBeenApproved: "De leningaanvraag is goedgekeurd.",
            loanApplicationHasBeenRejected: "De leningaanvraag is afgewezen.",
            loanApplications: "Leningaanvragen",
            loanDetails: "Leningdetails",
            loanDetailsSummary: "Samenvatting leningdetails.",
            loanDisbursementBankFarmer: "Leninguitbetaling (Bank -> Boer)",
            loanDisbursementPlan: "Leninguitbetalingsplan",
            loanProgram: "Leningprogramma",
            loanPrograms: "Leningprogramma's",
            loanRepaymentFarmerBank: "Leningaflossing (Boer -> Bank)",
            loanRepaymentPlan: "Leningaflossingsplan",
            missingApplicationId: "Aanvraag-ID ontbreekt.",
            moderate: "Matig",
            notApplicable: "N.v.t.",
            nitrogenContent: "Stikstofgehalte",
            noAdditionalQuestions: "Geen extra vragen.",
            noContractIsAlreadySignedOrWillBeSignedOffline: "Nee — contract is al ondertekend of wordt offline ondertekend",
            noMapCoordinatesForThisFarm: "Geen kaartcoordinaten voor dit bedrijf.",
            notes: "Notities",
            numberOfDisbursements: "Aantal uitbetalingen",
            numberOfInstallments: "Aantal termijnen",
            of: "van",
            openFile: "Bestand openen",
            orDragAndDropHere: "of sleep hierheen",
            overallLandSuitabilityScoreAndCategory: "Totale score en categorie bodemgeschiktheid.",
            overallScoreForLandSuitability: "Totale score bodemgeschiktheid",
            paid: "Betaald",
            paymentDetails: "Betalingsdetails",
            payments: "Betalingen",
            pending: "In afwachting",
            phoneNumber: "Telefoonnummer",
            phosphorusContent: "Fosforgehalte",
            pleaseEnterAValidInterestRateToGenerateRepaymentPlan: "Voer een geldig rentepercentage in om het aflossingsplan te genereren.",
            pleaseEnterAValidLoanAmountToGenerateDisbursementPlan: "Voer een geldig leningbedrag in om het uitbetalingsplan te genereren.",
            pleaseEnterAValidLoanAmountToGenerateRepaymentPlan: "Voer een geldig leningbedrag in om het aflossingsplan te genereren.",
            pleaseEnterNumberOfInstallmentsToGenerateRepaymentPlan: "Voer het aantal termijnen in om het aflossingsplan te genereren.",
            pleaseEnterYourCommentsOrInstructions: "Voer uw opmerkingen of instructies in.",
            pleaseProvideSpecificCommentsOrInstructionsInTheTextBoxBelowOnceSubmittedTheFarmerWillBeNotifiedYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Geef specifieke opmerkingen of instructies in het tekstvak. Na verzending wordt de boer geinformeerd. U krijgt een melding wanneer de boer de aanvraag bijwerkt.",
            polygon: "Polygoon",
            potassiumContent: "Kaliumgehalte",
            principalAndInterest: "Hoofdsom en rente",
            print: "Afdrukken",
            projectedYieldComparisonByYear: "Vergelijking verwachte opbrengst per jaar.",
            provinceState: "Provincie / Staat",
            question: "Vraag",
            recordsPerPage: "Records per pagina",
            regionDistrict: "Regio / District",
            reject: "Afwijzen",
            rejected: "Afgewezen",
            repaymentScheduleFromFarmerToBank: "Aflossingsschema van boer naar bank.",
            requestAdditionalInformation: "Extra informatie aanvragen",
            restoreDefault: "Standaard herstellen",
            search: "Zoeken",
            select: "Selecteren",
            selectFileToUploadTheContract: "Selecteer bestand om het contract te uploaden",
            selectNoIfYouHaveAlreadySignedTheContractWithTheApplicantFarmerSelectYesIfYouWantTheApplicantFarmerToSignTheLoanContractOnHisDimitraMobileApp: "Selecteer Nee als u het contract al met de aanvrager (boer) hebt getekend. Selecteer JA als de aanvrager (boer) het leningcontract in de Dimitra mobiele app moet tekenen.",
            send: "Verzenden",
            sendToBank: "Naar bank sturen",
            sentToBank: "Naar bank gestuurd",
            signedOffline: "Offline ondertekend",
            soilAnalysisReport: "Bodemanalyserapport",
            someDisclaimerOrShortExplainerAboutFollowingReports: "Korte disclaimer of toelichting bij de volgende rapporten.",
            srd: "SRD",
            startDate: "Startdatum",
            status: "Status",
            statusLegend: "Statuslegenda",
            submissionDate: "Indieningsdatum",
            success: "Gelukt",
            tapTheMapToExpandIt: "Tik op de kaart om te vergroten.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponses: "Deze sectie toont extra informatieverzoeken aan de boer en de antwoorden.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponsesYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Deze sectie toont extra informatieverzoeken aan de boer en de antwoorden. U krijgt een melding wanneer de boer de aanvraag bijwerkt.",
            totalInstallments: "Totaal aantal termijnen",
            totalInterestApprox: "Totale rente (ca.)",
            totalLoanAmount: "Totaal leningbedrag",
            totalPayment: "Totale betaling",
            totalRepayment: "Totale aflossing",
            transactionIdAndDate: "Transactie-ID en datum",
            typeYourLocationNameAddress: "Typ naam of adres van uw locatie",
            upcoming: "Binnenkort",
            uploadTheUnsignedContractAfterYouAttachAndSaveItWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Upload het niet-getekende contract. Na bijvoegen en opslaan wordt het naar de boer gestuurd om te tekenen. U ontvangt een melding zodra het is getekend.",
            user: "Gebruiker",
            userDetails: "Gebruikersgegevens",
            userRole: "Gebruikersrol",
            validation: "Validatie",
            viewFullReport: "Volledig rapport bekijken",
            viewGeolocation: "Geolocatie bekijken",
            villageTownCity: "Dorp / Stad",
            waitingSignatures: "Wachten op handtekeningen",
            warning: "Waarschuwing",
            year2025: "2025",
            year2026: "2026",
            yesAttachTheContractAndWeLlSendItToTheFarmerToSignInTheApp: "Ja — voeg het contract toe en wij sturen het naar de boer om in de app te tekenen",
            yieldPredictionReport: "Opbrengstvoorspellingsrapport",
            youMayUploadTheSignedContractForYourRecordsOrLeaveEmptyIfTheContractIsPrivateOrSignedOffline: "U kunt het getekende contract uploaden voor uw administratie, of leeg laten als het vertrouwelijk of offline is getekend.",
            yourRequestHasBeenSentTheFarmerWillBeNotified: "Uw verzoek is verzonden. De boer wordt geinformeerd.",
            yieldForecastChartAria: "Grafiek opbrengstvoorspelling",
            yearsAxisLabel: "Jaren",
            soilAnalysisSectionTitle: "Bodemanalyse",
            soilMetricNitrogenN: "Stikstof (N)",
            soilMetricPhosphorusP: "Fosfor (P2O5)",
            soilMetricPotassiumK: "Kalium (K2O)",
            soilAnalysisPlaceholderTitle: "Wat dit betekent (placeholder)",
            soilAnalysisPlaceholderBody: "Deze pagina toont een vereenvoudigde samenvatting van bodemvoedingsstoffen. Zodra de databron is gekoppeld, kan deze sectie worden uitgebreid met volledige bodemprofielen en aanbevelingen.",
            landSuitabilitySectionTitle: "Bodemgeschiktheid",
            overallSuitabilityScoreLabel: "Totale geschiktheidsscore",
            suitabilityFactorsPlaceholder: "Geschiktheidsfactoren (placeholder)",
            factorSoilQuality: "Bodemkwaliteit",
            factorClimateFit: "Klimaatgeschiktheid",
            factorWaterAvailability: "Beschikbaarheid water",
            factorRiskFactors: "Risicofactoren",
            landSuitabilityExpertFooter: "AI kan fouten maken; controleer bij lokale agronomen voordat u beslist.",
        },
        banks: {
            title: 'Banken',
            addNewBank: 'Nieuwe bank toevoegen',
            bankDetails: 'Bankgegevens',
            bank: 'Bank',
            bankTitle: 'Banktitel',
            attachBankLogo: 'Banklogo toevoegen',
            addImage: 'Afbeelding toevoegen',
            contactDetails: 'Contactgegevens',
            firstName: 'Voornaam',
            lastName: 'Achternaam',
            email: 'E-mail',
            phone: 'Telefoonnummer',
            enterHere: 'Voer hier in',
            apiIntegrationInfo: 'API-integratie informatie',
            apiBaseUrl: 'API-basis-URL',
            clientId: 'Client-ID / Publieke sleutel',
            clientSecret: 'Clientgeheim / Prive sleutel',
            accountAdminCredentials: 'Account-/beheerdergegevens',
            adminUsername: 'Beheerder gebruikersnaam',
            password: 'Wachtwoord',
            require2FA: '2FA vereisen',
            enable: 'Inschakelen',
            copy: 'Kopieren',
            regenerate: 'Opnieuw genereren',
            edit: 'Bewerken',
            back: 'Terug',
            cancel: 'Annuleren',
            save: 'Opslaan',
            firstNameInfo: 'Voornaam info',
            lastNameInfo: 'Achternaam info',
            emailInfo: 'E-mail info',
            phoneInfo: 'Telefoonnummer info',
            apiBaseUrlInfo: 'API-basis-URL info',
            clientIdInfo: 'Client-ID info',
            clientSecretInfo: 'Clientgeheim info',
            adminUsernameInfo: 'Beheerder gebruikersnaam info',
            passwordInfo: 'Wachtwoord info',
            contactPerson: 'Contactpersoon',
            management: 'Financieel beheer',
            editBank: 'Bank bewerken',
            changeImage: 'Afbeelding wijzigen',
            failedToLoadBankDetails: 'Laden van bankgegevens mislukt',
            bankUpdatedSuccessfully: 'Bank succesvol bijgewerkt',
            bankCreatedSuccessfully: 'Bank succesvol aangemaakt',
            errorUpdatingBank: 'Fout bij het bijwerken van de bank',
            errorCreatingBank: 'Fout bij het aanmaken van de bank',
            bankLogo: 'Banklogo',
            bankLogoPreview: 'Voorbeeld van banklogo',
            notAvailable: 'N.v.t.',
        },
        dashboard: {
            title: "Financieel dashboard",
            avgLoanAmount: "Gemiddeld leenbedrag",
            vsLastMonth: "vs vorige maand",
            totalApplications: "Totaal aantal aanvragen",
            approvalRate: "Goedkeuringspercentage",
            loanApplicationsChart: "Leenaanvragen",
            applicationsByStatus: "Aanvragen per status",
            applicationsByRegion: "Aanvragen per regio",
            regionBreakdown: "Verdeling per regio",
            averageLoanAmountTrend: "Trend gemiddeld leenbedrag",
            loanAmountOverTime: "Leenbedrag over tijd",
            avgAmount: "Gemiddeld bedrag"
        },
        status: {
            approved: "Goedgekeurd",
            pending: "In behandeling",
            waiting: "Wachtend",
            rejected: "Afgewezen"
        },
        reports: {
            today: "Vandaag",
            week: "Week",
            month: "Maand",
            year: "Jaar"
        },
    },
}
